import { APIAxiosInstance } from '@core/utils/api-axios-instance'
import { registerWebMFAInterceptors } from './mfaInterceptor'

// Type for the web authentication actions
interface WebAuthActions {
  setMFARequired: () => void
  setMFAExpired: () => void
}

/**
 * Sets up the MFA interceptors for the web application API clients
 *
 * This function should be called during app initialization with the
 * authentication actions from the useWebAuthentication hook
 *
 * @param authActions The authentication actions from useWebAuthentication hook
 */
export const setupWebMFAInterceptor = (
  // mfaStatusRef: MutableRefObject<MFAStatus>,
  authActions: WebAuthActions,
) => {
  // Register the MFA interceptors with the main API client
  registerWebMFAInterceptors(
    APIAxiosInstance,
    () => {
      // When MFA is required, trigger MFA required state
      // For fresh login scenarios, this will redirect to /mfa page
      authActions.setMFARequired()
    },
    () => {
      // When MFA token expires, trigger MFA expired state
      // This will show the MFA modal overlay
      authActions.setMFAExpired()
    },
  )
}

// Export types for use in other files
export type { WebAuthActions }
